export interface PolicyUsage {
    downloadGpxCount: number;
    cloudSaveActionCount: number;
    cloudSaveCount: number;
    importCount: number;
}

export default interface Policy {
    version: string;
    freeMaxTracks: number;
    freeDownloadGpxLimit: number;
    freeCloudSaveActionLimit: number;
    freeCloudSaveLimit: number;
    freeMaxRouteCreationDistanceKm: number;
    freeMaxOutputDistanceKm: number;
    freeCanImport: boolean;
    freeImportLimit: number;
    freeCanUseSubscriberRenderers: boolean;
    freeCanUseRideWithGps: boolean;
    freeCanUseWahoo: boolean;
    freeCanCloudSavePrivate: boolean;
    usage: PolicyUsage;
}

export const defaultPolicy: Policy = {
    version: 'client-default',
    freeMaxTracks: 1,
    freeDownloadGpxLimit: 1,
    freeCloudSaveActionLimit: 1,
    freeCloudSaveLimit: 1,
    freeMaxRouteCreationDistanceKm: 0,
    freeMaxOutputDistanceKm: 10,
    freeCanImport: true,
    freeImportLimit: 1,
    freeCanUseSubscriberRenderers: false,
    freeCanUseRideWithGps: false,
    freeCanUseWahoo: false,
    freeCanCloudSavePrivate: false,
    usage: {
        downloadGpxCount: 0,
        cloudSaveActionCount: 0,
        cloudSaveCount: 0,
        importCount: 0
    }
}
